<app-dialog-structure
  [title]="data ? 'Edit Broker' : 'Add Broker'"
  [submitButton]="data ? 'SAVE' : 'ADD'"
  (cancel)="cancel()"
  (submit)="submitEmitter()"
  [disableAction]="brokerForm.invalid || !contactsValiadtion() "
  >
  <div class="display-flex display-layout-column layout-gap-15">
    <div
      [formGroup]="brokerForm" class="display-layout-row layout-gap-10 layout-align-start"
      >
      <mat-form-field>
        <mat-label>Broker Name</mat-label>
        <input matInput formControlName="brokerName" type="text" required />
        @if (brokerForm.controls['brokerName'].hasError('required')) {
          <mat-error
            >
            Broker Name is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>Broker Status</mat-label>
        <mat-select formControlName="status" required>
          @for (status of status; track status) {
            <mat-option [value]="status.value"
              >{{ status.viewValue }}
            </mat-option>
          }
        </mat-select>

        @if (brokerForm.controls['status'].hasError('required')) {
          <mat-error>
            Broker Status is <strong>required</strong>
          </mat-error>
        }
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>
    <div class="display-layout-column layout-align-start">
      <div class="display-layout-row gap-60">
        <div class="display-layout-column" [formGroup]="contactsForm">
          <mat-form-field>
            <mat-label>Contact Person</mat-label>
            <input
              matInput
              formControlName="contactName"
              type="text"
              required
              />
            @if (contactsForm.controls['contactName'].hasError('required')) {
              <mat-error
                >
                Name of the Contact Person is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact Mail</mat-label>
            <input
              matInput
              formControlName="contactMail"
              type="text"
              required
              />
            @if (contactsForm.controls['contactMail'].hasError('required')) {
              <mat-error
                >
                Email of the Contact Person is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Contact Phonenumber</mat-label>
            <input
              matInput
              formControlName="phoneNumber"
              type="text"
              required
              />
            @if (contactsForm.controls['phoneNumber'].hasError('required')) {
              <mat-error
                >
                Phonenumber of the Contact Person is
                <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>

          <button
            mat-button
            [disabled]="contactsForm.invalid"
            (click)="addContact()"
            >
            Add Contact
          </button>
        </div>

        <div>
          <table mat-table [dataSource]="contactsTableSource">
            <ng-container matColumnDef="contactName">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let element">
                {{ element.contactPerson }}
              </td>
            </ng-container>

            <ng-container matColumnDef="contactMail">
              <th mat-header-cell *matHeaderCellDef>Mail</th>
              <td mat-cell *matCellDef="let element">
                {{ element.contactMail }}
              </td>
            </ng-container>

            <ng-container matColumnDef="contactPhone">
              <th mat-header-cell *matHeaderCellDef>Phone</th>
              <td mat-cell *matCellDef="let element">
                {{ element.phoneNumber }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button (click)="deleteContact(i)">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedContactColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedContactColumns"
            ></tr>
          </table>
          <mat-paginator
            #paginator
            [length]="contactsTableSource.data.length"
            [pageSizeOptions]="[5]"
            showFirstLastButtons
          ></mat-paginator>
          @if (!contactsValiadtion()) {
            <div class="warning">
              Please make sure that contacts are defined!
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</app-dialog-structure>
